function dateCompare() {
}
//On suppose que la date entrée a été validée auparavant
//au format dd/mm/yyyy
function getDate(strDate) {  
    //debugger;
    day = parseInt(strDate.substring(0,2));
    month = parseInt(strDate.substring(3, 5), 10) - 1;
    year = parseInt(strDate.substring(6, 10));

    d = new Date();
    d.setFullYear(year, month, day); 

    //L'ordre compte ! doit etre set du plus petit au plus grand, sinon le setteur échoue
//    d.setDate(day);
//    d.setMonth(month);
//    d.setYear(year);

    return d;  
}
//Retourne:
//   0 si date_1=date_2
//   1 si date_1>date_2
//  -1 si date_1<date_2	  
function compare(date_1, date_2){
    //debugger;
    diff = date_1.getTime()-date_2.getTime();
    return (diff==0?diff:diff/Math.abs(diff));
}

function checkDates() {
    if (!isDate(document.getElementById(getdtDebutTextBox()).value) || !isDate(document.getElementById(getdtFinTextBox()).value)) {
        return false;
    }
    if (compare(getDate(document.getElementById(getdtDebutTextBox()).value), getDate(document.getElementById(getdtFinTextBox()).value)) > 0) {
        alert('La date de début ne peut être postérieure à la date de fin');
        return false;
    }
    return true;
}

function Left(str, n){
    if (n <= 0)
        return "";
    else if (n > String(str).length)
        return str;
    else
        return String(str).substring(0,n);
}

function Right(str, n){
    if (n <= 0)
       return "";
    else if (n > String(str).length)
       return str;
    else {
       var iLen = String(str).length;
       return String(str).substring(iLen, iLen - n);       
    }
}

function FromDateFrToJavascript(DateToConvert) {
    return (getDate(DateToConvert))
    // Grumly 03/08/2010 -> supprimé la ligne ci-dessous car ne semble pas fonctionner par exemple avec la date du 03/08/2010 (on dirait qu'il s'embrouille avec les dates anglaises)
    //return new Date(parseInt(DateToConvert.substr(6,4)), parseInt(DateToConvert.substr(3,2)) - 1, parseInt(DateToConvert.substr(0,2)));
}

function FromDateJavascriptToFr(DateToConvert) {
    return formatNumberOnTwoDigits(DateToConvert.getDate()) + '/' + formatNumberOnTwoDigits(DateToConvert.getMonth() + 1) + '/' + DateToConvert.getFullYear();
}

function formatNumberOnTwoDigits(nNumber){
    if (parseInt(nNumber) < 10) {
        return '0' + String(nNumber);
    }
    else{
        return String(nNumber);
    }
}

function selectDuree() {
    var duree = document.getElementById(getduree());
    if (duree.selectedIndex > 0) {
        if (duree.options[duree.selectedIndex].value.toLowerCase() == 'firstvl') {
            document.getElementById(getdtDebutTextBox()).value = dtDebutVL;
        }
        else if (duree.options[duree.selectedIndex].value.toLowerCase() == 'histo') {
            document.getElementById(getdtDebutTextBox()).value = dtDebutVL;
            document.getElementById(getdtFinTextBox()).value = dtFinVL;
        }
        else {
            if (duree.options[duree.selectedIndex].value.toLowerCase() == 'hc') {
                document.getElementById(getdtDebutTextBox()).value = vardtDebCommon;
                document.getElementById(getdtFinTextBox()).value = vardtFinCommon;
            }
            else {
                if (duree.options[duree.selectedIndex].value.toLowerCase() == 'ytd') {
                    document.getElementById(getdtDebutTextBox()).value = FromDateJavascriptToFr(GetFirstJanuary(FromDateFrToJavascript(document.getElementById(getdtFinTextBox()).value)));
                }
                else {
                    document.getElementById(getdtDebutTextBox()).value = FromDateJavascriptToFr(DateAddMonthPlus1Day(FromDateFrToJavascript(document.getElementById(getdtFinTextBox()).value), -parseInt(duree.options[duree.selectedIndex].value)));
                }
            }
        }
    }

    if (typeof (getannee) !== 'undefined') {
        var annee = document.getElementById(getannee());
        annee.selectedIndex = 0;
    }

}

function selectAnnee() {
    var annee = document.getElementById(getannee());
    if (annee.selectedIndex > 0) {
        document.getElementById(getdtDebutTextBox()).value = '01/01/' + annee.options[annee.selectedIndex].value;
        document.getElementById(getdtFinTextBox()).value = '31/12/' + annee.options[annee.selectedIndex].value;
    }


    if (typeof (getduree) !== 'undefined') {
        var duree = document.getElementById(getduree());
        duree.selectedIndex = 0;
    }
}

function DateAddMonthMinus1Day(DateToWorkOn, ValueToBeAdded) {
    var dt = DateAdd('m', DateToWorkOn, ValueToBeAdded);
    dt = DateAdd('d', dt, -1);
    return (dt);
}

function DateAddMonthPlus1Day(DateToWorkOn, ValueToBeAdded) {
    var dt = DateAdd('m', DateToWorkOn, ValueToBeAdded);
    dt = DateAdd('d', dt, 1);
    return (dt);
}

function DateAdd(ItemType, DateToWorkOn, ValueToBeAdded) {
    switch (ItemType)
    {
        case 'd': //add days
            DateToWorkOn.setDate(DateToWorkOn.getDate() + ValueToBeAdded)
            break;
        case 'm': //add months
            DateToWorkOn.setMonth(DateToWorkOn.getMonth() + ValueToBeAdded)
            break;
        case 'y': //add years
            DateToWorkOn.setYear(DateToWorkOn.getFullYear() + ValueToBeAdded)
            break;
    }
    return DateToWorkOn;
}

function GetFirstJanuaryOfCurrentYear() {
    var curDate = new Date();
    return new Date(curDate.getFullYear(), 0, 1);
}

function GetFirstJanuary(DateToWorkOn) {
    var curDate = new Date();
    return new Date(DateToWorkOn.getFullYear(), 0, 1);
}

function getLastDecemberOfLastYear() {
    return (DateAdd('d', GetFirstJanuaryOfCurrentYear(), -1));
}


/**
* DHTML date validation script for dd/mm/yyyy. Courtesy of SmartWebby.com (http://www.smartwebby.com/dhtml/)
*/
// Declaring valid date character, minimum year and maximum year
var dtCh = "/";
var minYear = 1900;
var maxYear = 2100;

function isInteger(s) {
    var i;
    for (i = 0; i < s.length; i++) {
        // Check that current character is number.
        var c = s.charAt(i);
        if (((c < "0") || (c > "9"))) return false;
    }
    // All characters are numbers.
    return true;
}

function stripCharsInBag(s, bag) {
    var i;
    var returnString = "";
    // Search through string's characters one by one.
    // If character is not in bag, append to returnString.
    for (i = 0; i < s.length; i++) {
        var c = s.charAt(i);
        if (bag.indexOf(c) == -1) returnString += c;
    }
    return returnString;
}

function daysInFebruary(year) {
    // February has 29 days in any year evenly divisible by four,
    // EXCEPT for centurial years which are not also divisible by 400.
    return (((year % 4 == 0) && ((!(year % 100 == 0)) || (year % 400 == 0))) ? 29 : 28);
}
function DaysArray(n) {
    for (var i = 1; i <= n; i++) {
        this[i] = 31
        if (i == 4 || i == 6 || i == 9 || i == 11) { this[i] = 30 }
        if (i == 2) { this[i] = 29 }
    }
    return this
}

function isDate(dtStr) {
    var daysInMonth = DaysArray(12)
    var pos1 = dtStr.indexOf(dtCh)
    var pos2 = dtStr.indexOf(dtCh, pos1 + 1)
    var strDay = dtStr.substring(0, pos1)
    var strMonth = dtStr.substring(pos1 + 1, pos2)
    var strYear = dtStr.substring(pos2 + 1)
    strYr = strYear
    if (strDay.charAt(0) == "0" && strDay.length > 1) strDay = strDay.substring(1)
    if (strMonth.charAt(0) == "0" && strMonth.length > 1) strMonth = strMonth.substring(1)
    for (var i = 1; i <= 3; i++) {
        if (strYr.charAt(0) == "0" && strYr.length > 1) strYr = strYr.substring(1)
    }
    month = parseInt(strMonth)
    day = parseInt(strDay)
    year = parseInt(strYr)
    if (pos1 == -1 || pos2 == -1) {
        //alert("The date format should be : dd/mm/yyyy")
        return false
    }
    if (strMonth.length < 1 || month < 1 || month > 12) {
        //alert("Please enter a valid month")
        return false
    }
    if (strDay.length < 1 || day < 1 || day > 31 || (month == 2 && day > daysInFebruary(year)) || day > daysInMonth[month]) {
        //alert("Please enter a valid day")
        return false
    }
    if (strYear.length != 4 || year == 0 || year < minYear || year > maxYear) {
        //alert("Please enter a valid 4 digit year between " + minYear + " and " + maxYear)
        return false
    }
    if (dtStr.indexOf(dtCh, pos2 + 1) != -1 || isInteger(stripCharsInBag(dtStr, dtCh)) == false) {
        //alert("Please enter a valid date")
        return false
    }
    return true
}

function ValidateForm() {
    var dt = document.frmSample.txtDate
    if (isDate(dt.value) == false) {
        dt.focus()
        return false
    }
    return true
}

/*
        function DateAdd(ItemType, ValueToBeAdded, DateToWorkOn)
        {
        alert(1);
            switch (ItemType)
            {
                //date portion         
                case 'd': //add days
                    DateToWorkOn.setDate(DateToWorkOn.getDate() + ValueToBeAdded)
                    break;
                case 'm': //add months
                    DateToWorkOn.setMonth(DateToWorkOn.getMonth() + ValueToBeAdded)
                    break;
                case 'y': //add years
                    DateToWorkOn.setYear(DateToWorkOn.getFullYear() + ValueToBeAdded)
                    break;
                //time portion         
                case 'h': //add days
                    DateToWorkOn.setHours(DateToWorkOn.getHours() + ValueToBeAdded)
                    break;
                case 'n': //add minutes
                    DateToWorkOn.setMinutes(DateToWorkOn.getMinutes() + ValueToBeAdded)
                    break;
                case 's': //add seconds
                    DateToWorkOn.setSeconds(DateToWorkOn.getSeconds() + ValueToBeAdded)
                    break;
            }
            return DateToWorkOn;
        }
        function DateDiff(IntervalType, StartDate, EndDate)
        {
            var Interval = 0;
            var DevideBy = 1;
            if (EndDate < StartDate)
            {
                self.alert("StartDate can not be smaller than EndDate ");
                return Interval;
            }
            switch (IntervalType)
            {
                //date portion  
                case 'd': //add days
                    DevideBy = 1000 * 60 * 60 * 24;
                    Interval = EndDate - StartDate;
                    Interval = Math.floor(Interval / DevideBy);
                    

                    break;
                case 'm': //add months
                    var MonthsInFullYear = EndDate.getFullYear() - StartDate.getFullYear();
                    if (MonthsInFullYear > 0)
                    {
                        MonthsInFullYear = (MonthsInFullYear - 1) * 12;
                        Interval = EndDate.getMonth() + (12 - StartDate.getMonth());
                        Interval = Interval + MonthsInFullYear
                    }
                    else
                    {
                        Interval = EndDate.getMonth() - StartDate.getMonth();
                    }

                    break;
                case 'y': //years
                    Interval = EndDate.getFullYear() - StartDate.getFullYear();
                    break;

                //time portion        
                case 'h': //days
                    DevideBy = 1000 * 60 * 60;
                    Interval = EndDate - StartDate;
                    Interval = Math.floor(Interval / DevideBy);
                    break;
                case 'n': // minutes
                    DevideBy = 1000 * 60;
                    Interval = EndDate - StartDate;
                    Interval = Math.floor(Interval / DevideBy);
                    break;
                case 's': //seconds
                    DevideBy = 1000
                    Interval = EndDate - StartDate;
                    Interval = Math.floor(Interval / DevideBy);
                    break;
            }

            return Interval;
        } */